<template>
    <div>
        <TopLogo/>
        <div :class="!isMobile?'result':'mresult'">
            <div class="cont">
                <img class="icon"
                     :src="type!=3?require('@/assets/img/result-true.svg'):require('@/assets/img/NotOk.svg')"
                     alt/>
                <p class="secondBoldText" v-if="type==1">{{ langPage['v4-result']['TXT_paiemntrealiseavec'] }}</p>
                <p class="bigText">{{ titleList[type - 1] }}</p>
                <p class="tips font14"
                   v-if="type==1">{{ langPage['v4-result']['TXT_vousalleztresprochainement'] }}</p>
                <div class="type2" v-if="type==2">
                    <p class="tips font14 ">{{ langPage['v4-result']['TXT_votredemandedevirement'] }}</p>
                    <p class="tips font14 bold">{{ langPage['v4-result']['TXT_attention'] }}</p>
                    <p class="tips font14">{{ langPage['v4-result']['TXT_lexpediitonsera'] }} </p>
                </div>
                <p class="tips font14" v-if="type==3">{{ langPage['panier-validation']['TXT_paiementrefuse'] }}</p>
                <button class="black" @click="$router.replace('/Commandes')">
                    {{ langPage['v4-result']['TXT_accederausuivides'] }}
                </button>
                <button class="border" @click="$router.replace('/')">{{
                        langPage['v4-signsuc']['TXT_retouralaccueil']
                    }}
                </button>
                <!-- 背景部分 -->
                <img class="bgleft" src="@/assets/img/Cercle2.svg" alt/>
                <img class="bgright" src="@/assets/img/Cercle1.svg" alt/>
                <img class="line" src="@/assets/img/Trait2.svg" alt/>
            </div>
        </div>
        <BottomNav/>
        <BottomBox/>
    </div>

</template>
<script>
// import
import {mapState} from "vuex";
import TopLogo from "@/components/topLogo";
import BottomNav from "@/components/bottomNav";
import BottomBox from "@/components/bottomBox";

export default {
    name: "result",
    components: {BottomBox, BottomNav, TopLogo},
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            type: this.$route.query.type,//1 成功  2 银行卡转账支付成功  3 支付失败
            titleList: [
                "Merci pour votre commande",
                "Demande de paiement par virement",
                "Votre paiement a été refusé."
            ],
            params: {}
        };
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    mounted() {
        this.params = this.$route.query;
        // if (this.params.result==='SUCCESSED'){
        //     this.$api.order.getPayStatus({pid: this.params.pid}).then(res=>{
        //     });
        // }
    },
    methods: {}
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Checkout/result.less">
</style>
